<!--带搜索的下拉菜单-->
<template>
  <el-select v-model="selValue" filterable placeholder="请选择（输入文字搜索）" @change="bundleChange" :disabled="disabled">
    <el-option v-for="item in options" :key="item[labelValueOpt.value]" :label="item[labelValueOpt.label]" :value="item[labelValueOpt.value]"></el-option>
  </el-select>
</template>

<script>
import { getOrganizeType, getProjectList, queryConcreteLabelList } from "@/api/api";
import { IsNullOrEmpty } from "@/utils/m-utils";
export default {
  props: ["value", "type", "parentid", "name", "disabled", "isShowAll"], //value与父组件同步的值（一般是id），type要展示数据的类型（如果是联动的组件，type=children），parentid下拉菜单联动的id
  data() {
    return {
      options: [], //options的选项集
      selValue: "", //选中的值
      fatherId: "", //父组件联动的id
      labelValueOpt: {
        label: "label",
        value: "value",
      }, //options标签中，label、value对应数据中的键
      isEdit: true, //获取详情时，会触发监听parentid改变事件，导致清空子联动的数据，所以使用flag来控制
    };
  },
  methods: {
    //选中事件
    bundleChange(val) {
      this.$emit("input", val);
      for (let i = 0; i < this.options.length; i++) {
        if (this.options[i][this.labelValueOpt.value] === val) {
          this.$emit("update:name", this.options[i][this.labelValueOpt.label]);
          break;
        }
      }
    },
    //获取字典数据（仅2级节点）
    async getDictionaryByType(code) {
      this.labelValueOpt = {
        label: "name",
        value: "id",
      };
      const jsonData = await getDictListByCode({ code });
      this.options = jsonData.data.children;
    },
    //获取某一id下的节点数据
    async getDictionaryById() {
      this.labelValueOpt = {
        label: "name",
        value: "id",
      };
      const jsonData = await getSubDictList({ id: this.fatherId });
      this.options = jsonData.data;
    },
    //获取油罐型号
    async getOilCanModel() {
      this.labelValueOpt = {
        label: "model",
        value: "id",
      };
      const jsonData = await getOilcanModel({ type: 1 });
      this.options = jsonData.data;
    },
    //获取角色列表
    async getRole() {
      this.labelValueOpt = {
        label: "roleName",
        value: "id",
      };
      const jsonData = await getRoleTable({ pageNumber: 1, pageSize: 999 });
      //  console.log(jsonData)
      this.options = jsonData.data.list;
    },
    //查询砼标号
    async queryConcreteLabelList() {
      this.labelValueOpt = {
        label: "concreteGradeName",
        value: "id",
      };
      const jsonData = await queryConcreteLabelList({ pageNumber: 1, pageSize: 99999 });
      this.options = jsonData.data.list;
    },
    //获取组织下的项目
    async getProject() {
      this.labelValueOpt = {
        label: "organizeName",
        value: "id",
      };
      const jsonData = await getProjectList();
      this.options = jsonData.data;
    },
    //获取组织架构可以使用的管理层级类型
    async getOrganizeType() {
      this.labelValueOpt = {
        label: "orgTypeName",
        value: "orgType",
      };
      const jsonData = await getOrganizeType({
        pOrgId: this.parentid,
      });
      this.options = jsonData.data;
    },
    //灭火器类型
    fireType() {
      this.options = [
        { label: "干粉灭火器", value: 0 },
        { label: "二氧化碳灭火器", value: 1 },
        { label: "泡沫灭火器", value: 2 },
      ];
    },
    //设备来源
    deviceFrom() {
      this.options = [
        { label: "公司自购", value: 0 },
        { label: "公司租赁", value: 1 },
        { label: "班组自带", value: 2 },
      ];
    },
    //设备状态
    deviceStatus() {
      this.options = [
        { label: "正常", value: 0 },
        { label: "维修", value: 1 },
        { label: "报废", value: 2 },
      ];
    },
    //计量单位
    deviceUnit() {
      this.options = [
        { label: "辆", value: "辆" },
        { label: "台", value: "台" },
        { label: "个", value: "个" },
        { label: "组", value: "组" },
      ];
    },
    //绑定终端的类型
    getDeviceBindType() {
      this.options = [
        { label: "车载终端", value: 0 },
        { label: "油罐终端", value: 1 },
        { label: "安全帽", value: 2 },
        { label: "其它", value: 3 },
      ];
    },
    //获取油罐类型
    getOilcanType() {
      this.options = [
        { label: "固定油罐", value: 0 },
        { label: "油罐车", value: 1 },
      ];
    },
    //获取项目类型
    getProjectType() {
      this.options = [
        { label: "房建项目", value: 1 },
        { label: "路桥项目", value: 2 },
        { label: "市政项目", value: 3 },
        { label: "水利项目", value: 4 },
      ];
    },
    //供应商类型
    getSupplierType() {
      this.options = [
        { label: "劳务供应商", value: 1 },
        { label: "设备供应商", value: 2 },
        { label: "材料供应商", value: 3 },
      ];
      if (this.isShowAll) {
        this.options.unshift({ label: "全部业务范围", value: "" });
      }
    },
    //供应商属性
    getSupplierPro() {
      this.options = [
        { label: "内部供应商", value: 0 },
        { label: "外部供应商", value: 1 },
      ];
    },
    //合同类型
    getContractType() {
      let options = [];
      if (this.isShowAll) {
        options.push({ label: "全部", value: "" });
      }
      let dictionary = this.DICTIONARY.CONTRACT_TYPE;
      for (const key in dictionary) {
        options.push({ label: dictionary[key].name, value: dictionary[key].value });
      }
      this.options = options;
    },
    //获取税率
    getTaxRate() {
      let options = [];
      let dictionary = this.DICTIONARY.TAX_RATE;
      for (const key in dictionary) {
        options.push({ label: dictionary[key].name, value: dictionary[key].value });
      }
      this.options = options;
    },
  },
  mounted() {
    //判断组件需要获取的数据，如果要新增接口，写在这里type，并且在import引入方法
    switch (this.type) {
      case "fireType":
        this.fireType();
        break;
      case "deviceFrom":
        this.deviceFrom();
        break;
      case "deviceStatus":
        this.deviceStatus();
        break;
      case "deviceUnit":
        this.deviceUnit();
        break;
      case "insureCompany":
        this.getDictionaryByType("insurance_company");
      case "deviceType":
        this.getDictionaryByType("device_type");
        break;
      case "deviceBrand":
        this.getDictionaryByType("device_brand");
        break;
      case "gasolineType":
        this.getDictionaryByType("gasoline_type");
        break;
      case "oilcanModel":
        this.getOilCanModel();
        break;
      case "role":
        this.getRole();
        break;
      case "deviceBindType":
        this.getDeviceBindType();
        break;
      case "oilcanType":
        this.getOilcanType();
        break;
      case "project":
        this.getProject();
        break;
      case "projectType":
        this.getProjectType();
        break;
      case "supplierType":
        this.getSupplierType();
        break;
      case "organizeType":
        this.getOrganizeType();
        break;
      case "supplierPro":
        this.getSupplierPro();
        break;
      case "concreteLabelDictionary": //查询所有砼标号字典
        this.queryConcreteLabelList();
        break;
      case "contractType": //合同类型
        this.getContractType();
        break;
      case "taxRate": //税率
        this.getTaxRate();
        break;
    }
    this.selValue = this.value;
    setTimeout(() => {
      this.isEdit = false;
    }, 1000);
  },
  watch: {
    value: function (newValue, oldValue) {
      if (!IsNullOrEmpty(newValue)) {
        this.$nextTick(() => {
          this.selValue = newValue;
        });
      }
    },
    //监听联动的父id改变，如果改变了，清空这个组件，并且重新赋值
    parentid(newValue, oldValue) {
      if (IsNullOrEmpty(newValue)) return;
      this.$nextTick(() => {
        //如果联动的是deviceType_3  3级节点
        switch (this.type) {
          case "children":
            this.fatherId = newValue;
            if (!this.isEdit) {
              this.$emit("input", "");
              this.selValue = "";
            }
            this.getDictionaryById();
            break;
        }
      });
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/tools/select-search.vue